export class SelectFieldsTable {

    // Criterion Fields
    criterionFields = [
        'country',
        'city',
        'relocationPossibility',
        'relocationPackageIncluded',
        'workType',
        'contractType',
        'experienceLevel',
        'jobDisponibility',
        'studies',
        'driverLicense',
        'availableForTraveling',
        // 'confidentialSalaryLevel',
        'minimumSalaryLevel',
        'bonus',
        // 'averageBonusValue',
        'otherBenefits',
        'careerPossibility',
        'workProgram',
        'workSpace',
        'physicalType'
    ];
    criterionFieldsSlugs = [
        {id: 'country', text: 'Tara', disabled: false},
        {id: 'city', text: 'Oras', disabled: false},
        {id: 'relocationPossibility', text: 'Posibilitate relocare', disabled: false},
        {id: 'relocationPackageIncluded', text: 'Facilitati relocare', disabled: false},
        {id: 'workType', text: 'Tip job', disabled: false},
        {id: 'contractType', text: 'Tip contract', disabled: false},
        {id: 'experienceLevel', text: 'Nivel experienta', disabled: false},
        {id: 'jobDisponibility', text: 'Disponibilitate job', disabled: false},
        {id: 'studies', text: 'Studii', disabled: false},
        {id: 'driverLicense', text: 'Permis de  conducere', disabled: false},
        {id: 'availableForTraveling', text: 'Disponibilitate deplasare', disabled: false},
        // {id: 'confidentialSalaryLevel', text: 'Nivel Salarial confidential', disabled: false},
        {id: 'confidentialSalaryLevel', text: 'Nivel Salarial Minim Net', disabled: false},
        {id: 'bonus', text: 'Bonus', disabled: false},
        {id: 'averageBonusValue', text: 'Valoare medie a bonusului', disabled: false},
        {id: 'otherBenefits', text: 'Alte beneficii', disabled: false},
        {id: 'careerPossibility', text: 'Posibilitati cariera', disabled: false},
        {id: 'workProgram', text: 'Program de lucru', disabled: false},
        {id: 'workSpace', text: 'Spatiu de lucru', disabled: false},
        {id: 'physicalType', text: 'Efort fizic', disabled: false}

    ];

    // Work type
    selectWorkType = [
        'volunteer',
        'practice',
        'internship',
        'project',
        'temporary',
        'part_time',
        'full_time',
        'remote'
    ]

    // Work Space
    selectWorkSpace = [
        {
            valueName: 'interior',
            name: 'Interior'
        },
        {
            valueName: 'exterior',
            name: 'Exterior'
        }
    ]

    // Work Program
    selectWorkProgram = [
        {
            valueName: 'fixed',
            name: 'Fix'
        },
        {
            valueName: 'flexible',
            name: 'Flexibil'
        },
        {
            valueName: 'exchanges',
            name: 'Schimburi'
        },
        {
            valueName: 'weekend_work',
            name: 'Lucru in Week-End'
        },
        {
            valueName: 'other',
            name: 'Altul'
        }
    ]

    // Experience Level
    selectExperienceLevel = [
        'student',
        'entry_level',
        'junior',
        'specialist',
        'senior',
        'executive'

    ]

    // Bonus
    selectBonus = [
        {
            valueName: 'confidential',
            name: 'Confidential'
        },
        {
            valueName: 'not_offered',
            name: 'Nu se ofera'
        },
        {
            valueName: 'monthly',
            name: 'Lunar'
        },
        {
            valueName: 'quarterly',
            name: 'Semestrial'
        },
        {
            valueName: 'annual',
            name: 'Anual'
        },
        {
            valueName: 'another_interval',
            name: 'Alt interval'
        }
    ]

    // Studies
    selectStudies = [
        {
            valueName: 'high_school',
            name: 'Liceu / Școală profesionala'
        },
        {
            valueName: 'college',
            name: 'Colegiu / Studii postliceala'
        },
        {
            valueName: 'faculty',
            name: 'Facultate'
        },
        {
            valueName: 'master',
            name: 'Masterat'
        },
        {
            valueName: 'MBA',
            name: 'MBA'
        },
        {
            valueName: 'doctorate',
            name: 'Doctorat'
        }
    ]

    // Contract Type
    selectContractType = [
        'employment',
        'contractor'
    ]

    // Domains
    domains = [
        {
            name: 'Agricultura',
            subdomains: [
                'Cereale',
                'plante tehnice',
                'plante medicinale si aromatice',
                'cultura bio',
                'inputuri agricole(Seminte, pesticide, fertilizanti)'
            ]
        },
        {
            name: 'HORTICULTURA',
            subdomains: [
                'legumicultura',
                'pomicultura',
                'viticultura',
                'floricultura si amenajari peisagistice',
                'inputuri horticole(seminte, pesticide, fertilizanti)',
                'sere, solarii, echipamente',
                'material saditor'
            ]
        },
        {
            name: 'ZOOTEHNIE',
            subdomains: [
                'Bovine',
                'Caprine',
                'Ovine',
                'Suine',
                'Pasari',
                'Peste',
                'cabaline',
                'animale de companie',
                'nutritie animala',
                'reproductie animala',
                'genetica animala'
            ]
        },
        {
            name: 'MEDICINA VETERINARA',
            subdomains: [
                'Bovine',
                'Caprine',
                'Ovine',
                'Suine',
                'Pasari',
                'Peste',
                'cabaline',
                'animale de companie',
                'medicamente uz veterinar',
                'instrumentar laborator si ferme',
                'analize medicale'
            ]
        },
        {
            name: 'INDUSTRIA ALIMENTARA',
            subdomains: [
                'lactate si produse lactate',
                'carne si mezeluri',
                'paine si produse panificatie',
                'bauturi alcoolice si non alcoolice',
                'oua',
                'peste',
                'uleiuri alimentare',
                'ingrediente alimentare',
                'uleiuri non alimentare',
                'procesatori industria alimentara',
                'producatori industria alimentara',
                'echipamente  industria alimentara',
                'retail'
            ]
        },
        {
            name: 'MASINI si UTILAJE AGRICOLE',
            subdomains: [
                'MASINI agricole, horticole, zootehnice',
                'UTILAJE agricole, horticole, zootehnice',
                'PIESE DE SCHIMB',
                'ECHIPAMENTE',
                'ROBOTI',
                'sisteme de irigatii',
                'SOLUTII TRANSPORT',
                'COMBUSTIBILI SI ULEIURI',
                'SERVICII mecanizare'
            ]
        },
        {
            name: 'DEPOZITARE SI AMBALARE',
            subdomains: [
                'DEPOZITARE',
                'CONDITIONARE',
                'INSACUIRE',
                'SORTARE',
                'AMBALARE',
                'ETICHETARE'
            ]
        },
        {
            name: 'AGRICULTURA SMART  (DIGITALA SI DE PRECIZIE)',
            subdomains: [
                'SOFT MANAGEMENTUL FERMEI',
                'SOFT MANAGEMENTUL CULTURILOR',
                'SOFT MANAGEMENTUL PRECIPITATIILOR',
                'DRONE',
                'STATII METEO',
                'SENZORI',
                'GPS',
                'Roboti'
            ]
        },
        {
            name: 'CONSTRUCTIA  SI INTRETINEREA FERMEI/FABRICII',
            subdomains: [
                'PROIECTARE',
                'MATERIALE DE CONSTRUCTII',
                'ECHIPAMENTE PENTRU FERMA',
                'SISTEME DE VENTILARE',
                'SISTEME DE INCALZIRE',
                'GARDURI',
                'SISTEME DE SECURITATE',
                'SCULE, CONSUMABILE PENTRU FERMA',
                'ECHIPAMENTE DE PROTECTIE',
                'ECHIPAMENTE PENTRU CURATENIE',
                'PRODUSE DE IGIENA SI DEZINFENCTANTI'
            ]
        },
        {
            name: 'MANAGEMENTUL RESTURILOR VEGETALE SI ANIMALE',
            subdomains: [
                'GESTIONAREA DEJECTIIILOR',
                'PRELUCARAREA RESTURILOR VEGETALE',
                'STATII DE BIOGAZ',
                'ECHIPAMENTE SI INSTALATII'
            ]
        },
        {
            name: 'SERVICII',
            subdomains: [
                'CERCETARE STIINTIFICA',
                'TESTARE SI MULTIPLICARE ',
                'CERCETARI DE PIATA AGRICOLE',
                'CERCETARI DE PIATA ZOOTEHNICE',
                'CERCETARI DE PIATA ALIMENTARE',
                'CONSULTANTA  DE SPECIALITATE',
                'ANALIZE AGROCHIMICE SOL',
                'CADASTRU-TOPO',
                'ANALIZA ORGANOLEPTICĂ',
                'ANALIZE LABORATOR',
                'SERVICII DE MECANIZARE',
                'SERVICII DE DEPOZITARE SI AMBALARE',
                'FINANTARE BANCARA SI NONBANCARA',
                'LEASING',
                'FONDURI EUROPENE',
                'ASIGURARI',
                'RESURSE UMANE',
                'FINANCIAR-CONTABILITATE',
                'AUDIT ',
                'CERTIFICARI',
                'TRAINING SI DEZVOLTARE PROFESIONALA SI PERSONALA',
                'PROTECTIA MEDIULUI',
                'CONSULTANTA FONDURI EUROPENE'
            ]
        },
        {
            name: 'PISCICULTURA si ACVACULTURA',
            subdomains: [
                'PUIET PISCICOL',
                'NUTRITIE PISCICOLA',
                'ECHIPAMENTE PISCICOLE'
            ]
        },
        {
            name: 'APICULTURA',
            subdomains: [
                'FAMILII DE ALBINE',
                'STUPII, ACCESORII APICOLE'
            ]
        },
        {
            name: 'SILVICULTURA',
            subdomains: [
                'INFIINTAREA PLANTATIILOR',
                'INTRETINEREA PLANTATIILOR'
            ]
        },
    ]

    // Departments
    departments = [
        'Abatorizare',
        'Achizitii',
        'Achizitii animale',
        'Achizitii cereale si plante tehnice',
        'Achizitii legume',
        'Administrare ferme',
        'Administratia statului',
        'Admistrativ, servicii suport',
        'Agricultura digitala (hardware si software)',
        'Asigurarea calitatii',
        'Asigurari',
        'Asigurari agricole',
        'Audit',
        'Audit calitate',
        'Audit contabil',
        'Automatizari',
        'Banci / Servicii financiare',
        'Biochimie',
        'Bioenergie',
        'Biogaz',
        'Biolog',
        'Biosecuritatea produselor alimentare',
        'Biotehnolog',
        'Cadastru-Imobiliare',
        'Call center',
        'Cercetare de piață',
        'Cercetare-dezvoltare',
        'Certificare calitate',
        'Certificare standarde servicii',
        'Chimie',
        'Clinici veterinare',
        'Comert / Retail',
        'Constructii',
        'Consultanta de specialitate',
        'Contabilitate',
        'Controlul calității produselor agroalimentare',
        'Controlul si expertiza produselor agroalimentare',
        'Credit control',
        'Cultivarea plantelor',
        'Curatenie ',
        'Depozitare-Pastrare-Conditionare',
        'Echipamente',
        'Economie agricola',
        'Educatie, training',
        'Energie eoliana',
        'Energie solara',
        'Enologie',
        'Expozitii agro-alimentare',
        'Fabricarea mezelurilor',
        'Financiar-contabil',
        'Finantari bancare si non bancare',
        'Genetica si ameliorarea animalelor',
        'Genetică şi ameliorarea plantelor',
        'Geodezie',
        'Gestiune',
        'Grafica-Webdesign -DTP',
        'Hidrologie',
        'Imbunatatiri funciare',
        'Import – export',
        'Inginerie',
        'Internet / e-Commerce',
        'IT Hardware',
        'IT Software',
        'Juridic',
        'Jurnalism',
        'Laborator, analize',
        'Lemn si produse derivate',
        'Logistica',
        'Macelarie',
        'Management',
        'Marketing',
        'Medicina veterinara',
        'Merchandising / Promoteri',
        'Nutritia plantelor',
        'Nutritia si alimentatia animalelor',
        'Office / Back-office',
        'ONG / Voluntariat',
        'Pedologie',
        'Piscicultura si acvacultura',
        'Procesare',
        'Productie alimentara',
        'Productie horticola',
        'Productie vegetala',
        'Productie zootehnica',
        'Produse de curatenie, dezinfectie',
        'Produse petrochimice, energie verde',
        'Proiectare civila / industriala',
        'Proiectare sisteme de irigatii',
        'Protectia mediului',
        'Protectia muncii',
        'Protectia plantelor',
        'Publicitate',
        'Relatii clienti',
        'Relatii publice',
        'Reproductie animala',
        'Resurse Umane',
        'Sanatate si securitate in munca',
        'Secretariat',
        'Service / Reparatii',
        'Servicii financiare',
        'Servicii mecanizare',
        'Software agricol',
        'Somelier',
        'Statistica ',
        'Tehnologia cultivarii arborilor si arbustilor fructiferi',
        'Tehnologie alimentara ',
        'Tehnologii  în industria alimentară',
        'Tehnologii de crestere a animalelor',
        'Tehnologii de procesare a produselor agroalimentare',
        'Telecomunicatii',
        'Telemarketing',
        'Telesales',
        'Tipografii / Edituri',
        'Topografie',
        'Trading',
        'Transport / Distributie',
        'Turism-Agroturism',
        'Utilaje si service industrie alimentara',
        'Vanzari',
        'Vanzari produse fertilizarea plantelor',
        'Vanzari produse protectia plantelor',
        'Vanzari seminte',
        'Vanzari-Distributie',
        'Viticultura',
    ]

    // Languages
    languages = [
        'Arabă',
        'Bulgară',
        'Cehă',
        'Chineză',
        'Croată',
        'Daneză',
        'Ebraică',
        'Engleză',
        'Finlandeză',
        'Franceză',
        'Germană',
        'Greacă',
        'Italiană',
        'Japoneză',
        'Maghiară',
        'Norvegiană',
        'Olandeză',
        'Persană',
        'Poloneză',
        'Portugheză',
        'Română',
        'Rusă',
        'Sarbă',
        'Slovacă',
        'Slovenă',
        'Spaniolă',
        'Suedeză',
        'Turcă',
        'Ucraineană',
    ]

    // Years
    years = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10
    ]

    // Locations
    locations = [
        {
            country: 'Romania',
            cities: ['Bucuresti', 'Galati']
        },
        {
            country: 'Moldova',
            cities: ['Chisinau', 'Cahul']
        }
    ]

    // Other Benefits
    selectOtherBenefits = [
        'Bonuri de Masa',
        'Bonusuri de Vacanta',
        'Masini de Serviciu',
        'Asigurari de Viata',
        'Pachet de Sanatate',
        'Masa',
        'Cazare',
        'Produse finite',
        'Prestari Servicii',
        'Cursuri in Tara',
        'Cursuri in afara Tarii',
        'Alte Beneficii'
    ]

    // Career Possibility
    selectCareerPossibility = [
        {
            id: 'currentPositionUpgrade',
            text: 'Creste in Pozitia Actuala',
            additional: false
        },
        {
            id: 'otherPositionInCountry',
            text: 'Pozitie Ierarhica Superioara',
            additional: false
        },
        {
            id: 'otherPositionOutsideCountry',
            text: 'Alte Pozitii in Tara',
            additional: false
        },
        {
            id: 'superiorPosition',
            text: 'Alte Pozitii in Afara Tarii',
            additional: false
        },
    ]

    // Drive License
    driveLicense = [
        {
            id: 'no',
            text: 'Fara',
        },
        {
            id: 'A',
            text: 'A',
        },
        {
            id: 'B',
            text: 'B',
        },
        {
            id: 'C',
            text: 'C',
        },
        {
            id: 'D',
            text: 'D',
        },
        {
            id: 'E',
            text: 'E',
        },
        {
            id: 'Tr',
            text: 'Tr',
        },
        {
            id: 'Tb',
            text: 'Tb',
        },
        {
            id: 'Td',
            text: 'Td',
        },
    ]

    // Category
    selectCategory = [
        {
            id: 'test',
            text: 'Test',
        },
        {
            id: 'test2',
            text: 'Test 2',
        },
    ]

    // Mandatory Categories
    selectMandatoryCategories = [
        {
            id: 'test',
            text: 'Categorie Test',
        },
        {
            id: 'test2',
            text: 'Categorie Test 2',
        },
    ]

    // Job Abilities
    selectJobAbilities = [
        {
            id: 'test',
            text: 'Tester'
        },
        {
            id: 'Parasutist',
            text: 'Parasutist'
        }
    ]
    //Weight Lifting
    selectWeightLiftingRequired=[
        {
            valueName:'no',
            name:'Nu'
        },
        {
            valueName:'maximum_10_kg',
            name:'Pana in 10 kg'
        },
        {
            valueName:'maximum_25_kg',
            name:'Pana in 25 kg'
        },
        {
            valueName:'maximum_50_kg',
            name:'Pana in 50 kg'
        },
    ]

    //workTemperature
    selectWorkTemperature=[
        {
            valueName:'no',
            name:'Nu'
        },
        {
            valueName:'yes',
            name:'Da'
        },
        {
            valueName:'low_temperature',
            name:'Doar la temperaturi scazute'
        },
        {
            valueName:'high_temperature',
            name:'Doar la temperaturi ridicate'
        },
    ]

    //naveta
    selectUserCommute=[
        {
            valueName:'Nu',
            name:'Nu'
        },
        {
            valueName:'Pana in 100km',
            name:'Pana in 100km'
        },
        {
            valueName:'Pana in 500km',
            name:'Pana in 500km'
        }
    ]

    selectOtherBenefit = [
        {
            id: 'Bonuri de masa',
            text: 'Bonuri de masa'
        },
        { id: 'Bonusuri de vacanta',
            text: 'Bonusuri de vacanta'
        },
        {
            id:'Asigurari de viata',
            text:'Masini de Serviciu'
        },
        {
            id:'Pachet de sanatate',
            text:'Pachet de sanatate'
        },
        {
            id:'Masa',
            text:'Masa'
        },
        {
            id:'Cazare',
            text:'Cazare'
        },
        {
            id:'Produse finite',
            text:'Produse finite'
        },
        {
            id:'Prestari servicii',
            text:'Prestari servicii'
        },
        {
            id:'Cursuri in tara',
            text:'Cursuri in tara'
        },
        {
            id:'Cursuri in afara tarii',
            text:'Cursuri in afara tarii'
        },
        {
            id:'Alte beneficii',
            text:'Alte beneficii'
        }
    ]

    selectWorkingTools: [
        {
            id:'Masina',
            text: 'Masina'
        },
        {
            id:'Telefon',
            text: 'Telefon'
        },
        {
            id:'PC/Tableta',
            text: 'PC/Tableta'
        },
        {
            id:'Altele',
            text: 'Altele'
        }
    ]
}
